import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useRedEstado } from "@/lib/red";
import { useAuth } from "@/context/AuthContext";
import { Section } from "@/components/common/DetailFields";

export const DeleteAccountSection = () => {
  const { isOwner, setUser } = useAuth();
  const [e] = useRedEstado();
  const nav = useNavigate();
  const [txt, setTxt] = useState("");
  const [busy, setBusy] = useState(false);
  if (!isOwner || !e) return null;
  const del = async () => {
    setBusy(true);
    try { await api.post("/cuenta/borrar", { confirmacion: txt }); toast.success("Tu cuenta fue borrada"); setUser(null); nav("/login", { replace: true }); } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <Section title="Borrar cuenta" testid="config-delete-account">
      {e.es_admin ? (
        <p data-testid="delete-account-admin-msg" className="text-sm c-text-2">Las cuentas de administrador no se pueden borrar desde la app</p>
      ) : (
        <div className="space-y-2.5">
          <p className="text-sm c-text-2">Borra tu cuenta completa: contactos, capturas, archivos, conexiones, invitaciones, solicitudes y avisos. No se puede deshacer. Los referidos que otros ya registraron conservan solo tu nombre público.</p>
          <input data-testid="delete-account-confirm-input" className="c-input" placeholder='Escribe "BORRAR" para confirmar' value={txt} onChange={(ev) => setTxt(ev.target.value)} />
          <button data-testid="delete-account-btn" disabled={txt.trim() !== "BORRAR" || busy} onClick={del} className="w-full py-2.5 rounded-xl bg-red-600 text-white font-semibold flex items-center justify-center gap-2 disabled:opacity-40">
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Trash2 className="w-4 h-4" />} Borrar mi cuenta
          </button>
        </div>
      )}
    </Section>
  );
};
